import * as bigInt from 'big-integer';
import {Sha512_224} from './SHA512_224';
import { Signature } from './Signature';

export class DSA{
    
    q: bigInt.BigInteger;
    p: bigInt.BigInteger;
    g: bigInt.BigInteger;

    constructor(){
        this.q =  bigInt("800000000000000000000000000000000000000000000000000000BD",16);
        this.p =  bigInt('4000000000000000000000000000000000000000000000000000005E9',16); 
        this.g =  bigInt(2).pow(this.p.prev().divide(this.q)).mod(this.p);
    }
    getSignature(message: string, privateKey: string):Signature{
        
        var x = bigInt(privateKey,10);
        if((x.compare(this.q)>-1)||(x.compare(0)<1)){
            return undefined;
        }
        var openKey = this.g.modPow(x,this.p);
        var k = bigInt.randBetween(0,this.q);
        var r = (this.g.modPow(k,this.p)).mod(this.q);
        var hash = bigInt(Sha512_224.getHash(message),16);
        var s = (k.modInv(this.q).multiply(hash.plus(x.multiply(r)))).mod(this.q);
        return new Signature(r,s,openKey);
    }

    verify(message: string, signature: Signature):boolean{
        var w = signature.s.modInv(this.q);
        var hash = bigInt(Sha512_224.getHash(message),16);
        var u1 = hash.multiply(w).mod(this.q);
        var u2 = signature.r.multiply(w).mod(this.q);
        var v =  (this.g.modPow(u1, this.p).multiply(signature.openKey.modPow(u2,this.p)).mod(this.p)).mod(this.q);
        return v.equals(signature.r);      
    }

}
